import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import injectSheet from 'react-jss';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import QuestionOutline from 'material-ui/svg-icons/action/help-outline';
import CloseIcon from 'material-ui/svg-icons/navigation/close';
import ChatIcon from 'material-ui/svg-icons/communication/chat';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import WalkThruIcon from 'material-ui/svg-icons/maps/directions';
import WhatsHotIcon from 'material-ui/svg-icons/social/whatshot';

import HelpDrawer from '../../components/tc-ui/help-drawer';
import { closeHelpWidget, openHelpWidget } from '../../stores/ui/components/helpwidget/helpwidget-actions';
import { openWalkThru } from '../../stores/ui/components/walkthru/walkthru-actions';
import { loadHelpSideBarPages } from '../../components/sidebarHelp/actions';
import HelpWidgetOption from './help-widget-option';

const styles = {
  floatingHelpIcon: {
    bottom: '25px',
    right: '25px',
    position: 'fixed',
    zIndex: 10001,
    transition: 'transform 455ms',
    transform: 'rotate(0)',
    '&.open': {
      transform: 'rotate(90deg)',
      right: '400px',
    },
  },
  floatingHelpIcons: {
    bottom: '90px',
    opacity: 0,
    position: 'fixed',
    right: '-9999px',
    zIndex: 1e4,
    '&.open': {
      right: '448px',
      opacity: '1',
      '&>div': {
        opacity: '1',
      },
    },
    '&>div': {
      display: 'block',
      position: 'absolute',
      opacity: '0',
      zIndex: 10001,
    },
    '&>div:nth-child(1)': {
      bottom: '0',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '255ms !important',
    },
    '&>div:nth-child(2)': {
      bottom: '50px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '285ms !important',
    },
    '&>div:nth-child(3)': {
      bottom: '100px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '315ms !important',
    },
    '&>div:nth-child(4)': {
      bottom: '150px',
      transition: 'all 455ms cubic-bezier(0.06,.93,.77,1) !important',
      transitionDelay: '345ms !important',
    },
  },
};

class HelpWidget extends Component {
  componentDidMount() {
    this.props.loadHelpSideBarPages();
  }

  onTouchTap = () => {
    const { isOpen } = this.props;
    if (isOpen) {
      this.props.closeHelpWidget();
    } else {
      this.props.openHelpWidget();
    }
  }

  onKnowledgeBaseClick = () => this.clickAndClose(() => window.open('http://support.tourconnect.com'))

  onChatClick = () => this.clickAndClose(() => window.Intercom('show')); // eslint-disable-line new-cap

  onWalkThruClick = (tourId) => {
    window.HelpHero.startTour(tourId);
    this.clickAndClose();
  }

  onNewReleasesClick = () => this.clickAndClose(window.Beamer.show);

  clickAndClose = (fn) => {
    this.props.closeHelpWidget();
    if (typeof fn === 'function') fn();
  }

  isUrlMatch = (str) => window.location.pathname.indexOf(str) > -1;

  render() {
    const {
      classes,
      isOpen,
      isKnowledgeBaseActive,
      isTourActive,
      isNewFeaturesActive,
      acctCreationReason = '',
      companyType,
    } = this.props;
    const isBuyer = companyType === 'Contractor';
    const isForPF = acctCreationReason.indexOf('find-new') > -1;
    const isPFBuyer = isBuyer && isForPF;
    const allTours = [{
      tourId: 'mkV3FeRHYhp',
      match: this.isUrlMatch('/dashboard') && isPFBuyer,
    },
    {
      tourId: 'Znrl7zI0riI',
      match: this.isUrlMatch('/profile') && isPFBuyer,
    },
    {
      tourId: 'jO8080xVkoC',
      match: this.isUrlMatch('/partner-finder/results') && isPFBuyer,
    },
    {
      tourId: 'e4yz805kLVq',
      match: this.isUrlMatch('/connections/requests') && isPFBuyer,
    },
    {
      tourId: 'Mtbrtk68zoc',
      match: this.isUrlMatch('/assets-landing') && isBuyer,
    },
    {
      tourId: 'OF9wW2uSoZ6',
      match: this.isUrlMatch('/dashboard') && isBuyer && !isForPF,
    },
    {
      tourId: 'AAGbLUfcFp1',
      match: this.isUrlMatch('/onboarding') && !isBuyer,
    },
    {
      tourId: 'Y7wNi93TDEj',
      match: this.isUrlMatch('/profile') && isBuyer && !isForPF,
    },
    {
      tourId: '8BbgfvvQKN2',
      match: this.isUrlMatch('/profile') && !isBuyer,
    },
    {
      tourId: 'WPkGk9xn7aH',
      match: this.isUrlMatch('/partner-finder/results') && !isPFBuyer,
    },
    {
      tourId: 'kI2w9OAMv7C',
      match: this.isUrlMatch('/connections/requests') && !isPFBuyer,
    },
    {
      tourId: 'b2Gqu6LyLie',
      match: this.isUrlMatch('/contracting/supplier-dashboard') && !isBuyer,
    },
    {
      tourId: 'T52TdHb44se',
      match: this.isUrlMatch('/contracting/buyer-dashboard') && isBuyer,
    },
    {
      tourId: 'Ku845gQzC3h',
      match: this.isUrlMatch('/contracting/template-list') && !isBuyer,
    },
    {
      tourId: 'BuRYzPvENJt',
      match: this.isUrlMatch('/contracting/contract-list') && !isBuyer,
    }];
    const findTour = allTours.find(obj => obj.match);
    return (
      <div>
        <FloatingActionButton
          secondary={isOpen}
          className={`${classes.floatingHelpIcon}${isOpen ? ' open' : ''}`}
          backgroundColor="#F6653C"
          onTouchTap={this.onTouchTap}
        >
          { isOpen ? <CloseIcon/> : <QuestionOutline /> }
        </FloatingActionButton>
        <HelpDrawer />
        <div className={`${classes.floatingHelpIcons}${isOpen ? ' open' : ''}`}>
          <HelpWidgetOption
            icon={<SchoolIcon />}
            onTouchTap={this.onKnowledgeBaseClick}
            isActive={isKnowledgeBaseActive}
            hintText="Support Articles and Videos"
          />
          <HelpWidgetOption
            icon={<ChatIcon />}
            onTouchTap={this.onChatClick}
            isActive
            hintText="Live Chat Support"
          />
          <HelpWidgetOption
            icon={<WalkThruIcon />}
            isActive={Boolean(findTour)}
            onTouchTap={() => this.onWalkThruClick(findTour.tourId)}
            hintText="Walkthrough"
          />
          <HelpWidgetOption
            icon={<WhatsHotIcon color="rgb(255, 0, 0)" style={{ fill: 'rgb(255, 0, 0)' }} />}
            onTouchTap={this.onNewReleasesClick}
            isActive={isNewFeaturesActive}
            backgroundColor="#ffffff"
            hintText="New Releases !"
          />
        </div>
    </div>
  );
  }
}

HelpWidget.propTypes = {
  classes: PropTypes.object,
  closeHelpWidget: PropTypes.func,
  isKnowledgeBaseActive: PropTypes.bool,
  isLiveChatActive: PropTypes.bool,
  isNewFeaturesActive: PropTypes.bool,
  isOpen: PropTypes.bool,
  isSupportDeskActive: PropTypes.bool,
  isTourActive: PropTypes.bool,
  loadHelpSideBarPages: PropTypes.func,
  onTouchTap: PropTypes.func,
  openHelpWidget: PropTypes.func,
  openWalkThruFn: PropTypes.func,
  acctCreationReason: PropTypes.string,
  companyType: PropTypes.string,
};

export default connect(({ ui, user }) => ({
  isKnowledgeBaseActive: ui.helpwidget.get('isKnowledgeBaseActive'),
  isLiveChatActive: ui.helpwidget.get('isLiveChatActive'),
  isNewFeaturesActive: ui.helpwidget.get('isNewFeaturesActive'),
  isOpen: ui.helpwidget.get('isOpen'),
  isSupportDeskActive: ui.helpwidget.get('isSupportDeskActive'),
  isTourActive: ui.walkthru.get('isTourReady'),
}), {
  closeHelpWidget,
  loadHelpSideBarPages,
  openHelpWidget,
  openWalkThruFn: openWalkThru,
})(injectSheet(styles)(HelpWidget));




// WEBPACK FOOTER //
// ./src/app/components/tc-ui/help-widget.jsx